<template>
  <div class="bar-spacer"></div>
</template>